import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../state/reducers';
import { hasAggregation } from '../searchFiltersBarUtils';

const mapState = ({ aggregations }: StateType) => {
  return {
    shouldDisplayVille: hasAggregation(aggregations, 'ville'),
    shouldDisplayPubli: hasAggregation(aggregations, 'publi'),
    shouldDisplaySolution: hasAggregation(aggregations, 'solution'),
  };
};

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
